import { orderHasPersonalizedName } from "../../utils/orderLineDisplay";

export function pieceNameText(item) {
  return [item?.customNameAr, item?.customNameEn]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .join(" · ");
}

export function NamedPieceBadge({ item, className = "" }) {
  if (!item?.hasPersonalizedName) return null;
  const name = pieceNameText(item);
  return (
    <span className={`inline-flex items-center gap-1 rounded-md bg-fuchsia-600 px-2 py-0.5 text-[11px] font-bold text-white ${className}`}>
      باسم
      {name ? <span>{name}</span> : null}
    </span>
  );
}

export function OrderNameMark({ order, className = "" }) {
  if (!orderHasPersonalizedName(order)) return null;
  return (
    <span className={`inline-flex items-center rounded-md bg-fuchsia-600 px-2 py-0.5 text-[11px] font-bold text-white ${className}`}>
      فيه اسم
    </span>
  );
}
